(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  const atcObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.closest('.product-wrapper').querySelector('.sticky-atc').classList.remove('active');
        } else {
          entry.target.closest('.product-wrapper').querySelector('.sticky-atc').classList.add('active');
        }
      });
    },
    {
      threshold: 0.25,
    }
  );

  atcObserver.observe(document.querySelector('#AddToCartButton'));
  document.querySelector('.sticky-atc').addEventListener('click', () => {
    document.querySelector('.product-form').scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('marquee-scroller')) {
    class MarqueeScroller extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.marquee__track');
        this.group = this.querySelector('.marquee__group');
        if (!this.track || !this.group || !this.group.children.length) return;

        this.speed = parseFloat(this.dataset.speed) || 60;
        this.style.setProperty('--marquee-direction', this.dataset.direction === 'right' ? 'reverse' : 'normal');

        this.observer = new ResizeObserver(() => this.update());
        this.observer.observe(this);
        this.observer.observe(this.group);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      update() {
        const groupWidth = this.group.offsetWidth;
        if (!groupWidth) return;

        // Enough copies of the group to always cover the visible width while scrolling
        const needed = Math.ceil(this.offsetWidth / groupWidth) + 1;
        const clones = this.track.querySelectorAll('.marquee__group[aria-hidden]');

        if (clones.length + 1 !== needed) {
          clones.forEach((clone) => clone.remove());
          for (let i = 1; i < needed; i++) {
            const clone = this.group.cloneNode(true);
            clone.setAttribute('aria-hidden', 'true');
            clone.querySelectorAll('[data-shopify-editor-block]').forEach((el) => el.removeAttribute('data-shopify-editor-block'));
            this.track.appendChild(clone);
          }
        }

        this.style.setProperty('--marquee-distance', `${groupWidth}px`);
        this.style.setProperty('--marquee-duration', `${groupWidth / this.speed}s`);
        this.classList.add('is-ready');
      }
    }

    customElements.define('marquee-scroller', MarqueeScroller);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;              
            }
          })
          .then(() => {
            setTimeout(() => {
              this.querySelector('.scroll-animation').classList.add('scroll-animation--active')
            }, 500)            
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 100px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-player"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('video-player')) {
    class VideoPlayer extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.button = this.querySelector('.video-player__play');
        this.template = this.querySelector('template');
        this.userPaused = false;

        if (this.button) this.button.addEventListener('click', () => this.play());

        if (this.video) {
          this.video.addEventListener('play', () => {
            this.userPaused = false;
            this.toggleAttribute('playing', true);
          });
          this.video.addEventListener('pause', () => {
            // Pauses from scrolling out of view shouldn't stop autoplay when it scrolls back in
            if (!this.pausedOffscreen) this.userPaused = true;
            this.pausedOffscreen = false;
            this.toggleAttribute('playing', false);
          });
          if (!this.video.controls) this.video.addEventListener('click', () => this.toggle());
          if (this.dataset.autoplay === 'true') this.autoplayInView();
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      // Autoplay only while on screen, and not for visitors who prefer reduced motion
      autoplayInView() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        this.video.muted = true;
        this.observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting && !this.userPaused) {
              this.video.play().catch(() => {});
            } else if (!entry.isIntersecting && !this.video.paused) {
              this.pausedOffscreen = true;
              this.video.pause();
            }
          },
          { threshold: 0.25 }
        );
        this.observer.observe(this);
      }

      play() {
        if (this.template) {
          const frame = this.querySelector('.video-player__frame');
          frame.querySelectorAll('.video-player__poster, .video-player__play').forEach((el) => el.remove());
          frame.appendChild(this.template.content.cloneNode(true));
          this.template.remove();
          this.template = null;
          this.toggleAttribute('playing', true);
          frame.querySelector('iframe').focus();
          return;
        }

        if (this.video) this.video.play().catch(() => {});
      }

      toggle() {
        if (this.video.paused) {
          this.play();
        } else {
          this.video.pause();
        }
      }
    }

    customElements.define('video-player', VideoPlayer);
  }

  } catch(e) { console.error(e); }
})();
})();
